import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';
import { adminLogin } from '../data/api';
import { useAdmin } from '../context/AdminContext';
import Logo from '../components/Logo';
import { toast } from 'sonner';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAdmin();
  const [form, setForm] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await adminLogin(form.username, form.password);
      login(data.token);
      toast.success('Connexion réussie');
      navigate('/admin');
    } catch (err) {
      toast.error('Identifiants invalides');
    } finally {
      setLoading(false);
    }
  };

  const field =
    'w-full bg-transparent border-b border-[#f4efe6]/25 font-sans-elegant text-[#f4efe6] py-3 focus:outline-none focus:border-[#c8a469] transition-colors placeholder:text-[#f4efe6]/40';

  return (
    <div className="min-h-screen bg-[#1b2331] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10">
          <Logo dark />
        </div>
        <div className="border border-[#f4efe6]/10 p-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-11 h-11 border border-[#c8a469]/40 flex items-center justify-center">
              <Lock className="w-4 h-4 text-[#c8a469]" />
            </div>
            <div>
              <h1 className="font-serif-display text-2xl text-[#f4efe6] leading-none">Espace Admin</h1>
              <p className="font-sans-elegant text-[0.62rem] tracking-wide-2 uppercase text-[#f4efe6]/50 mt-1">
                Accès réservé
              </p>
            </div>
          </div>

          <form onSubmit={onSubmit} className="space-y-6">
            <div>
              <label className="font-sans-elegant text-[0.62rem] tracking-wide-2 uppercase text-[#f4efe6]/50">
                Identifiant
              </label>
              <input
                value={form.username}
                onChange={(e) => setForm((f) => ({ ...f, username: e.target.value }))}
                required
                className={field}
                autoComplete="username"
              />
            </div>
            <div>
              <label className="font-sans-elegant text-[0.62rem] tracking-wide-2 uppercase text-[#f4efe6]/50">
                Mot de passe
              </label>
              <input
                type="password"
                value={form.password}
                onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
                required
                className={field}
                autoComplete="current-password"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="group w-full flex items-center justify-center gap-3 bg-[#c8a469] text-[#1b2331] font-sans-elegant text-xs tracking-wide-2 uppercase px-8 py-4 hover:bg-[#f4efe6] transition-colors disabled:opacity-60"
            >
              {loading ? '…' : 'Se connecter'}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
